import Axios from "axios";

export const ADD_INGREDIENTS = 'ADD_INGREDIENTS';
export const REMOVE_INGREDIENTS = 'REMOVE_INGREDIENTS';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH = 'AUTH';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export const LOGOUT = 'LOGOUT';
export const CHECK_INITIAL_AUTH = 'CHECK_INITIAL_AUTH';

export const syncAdd = (payload) => {
    return {
        type : ADD_INGREDIENTS,
        ingredientsType : payload
    }
}

// action creators
export const addIngredients = (payload) => {
    return (dispatch) => {
        return dispatch(syncAdd(payload));
    }
}

export const removeIngredients = (payload) => {
    return {
        type : REMOVE_INGREDIENTS,
        ingredientsType : payload
    }
}

export const onAuth = (email, password, isSignUp) => {
    return (dispatch) => {
        dispatch(onAuthStart());
        const authData = {
            email : email,
            password : password,
            returnSecureToken : true
        }
        let url = isSignUp ? 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyCwZZFmQF0JPWFHp3GXzAJln45tFkdDJo8' :
        'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyCwZZFmQF0JPWFHp3GXzAJln45tFkdDJo8'
        Axios.post(url,
            authData).then(
                response => {
                    localStorage.setItem('token',response.data.idToken);
                    localStorage.setItem('time', new Date().getTime() + response.data.expiresIn);
                    localStorage.setItem('userId' ,  response.data.localId);
                    dispatch(onAuthSucces(response.data));
                    dispatch(checkTokenValidity(response.data.expiresIn));
                }
            ).catch(
                error => {
                    dispatch(onAuthError(error));
                }
            );
    }
}

export const onAuthSucces = (authData) => {
    return {
        type : AUTH_SUCCESS,
        userId : authData.localId,
        token : authData.idToken
    }
}

export const onAuthError = (error) => {
    return {
        type : AUTH_ERROR,
        error : error
    }
}

export const onAuthStart = () => {
    return {
        type : AUTH
    }
}

export const removeError = () => {
    return {
        type : REMOVE_ERROR
    }
}

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('time');
    localStorage.removeItem('userId');
    return {
        type : LOGOUT
    }
}

export const checkTokenValidity = (time) => {
    return (dispatch) => {
       setTimeout(() => dispatch(logout()), time * 1000);
    }
}

export const checkTokenAvailableInLocal = () => {
    return dispatch => {
        let token = localStorage.getItem('token');
        if(!token){
            dispatch(logout());
        }else{
            let time = localStorage.getItem('time');
            if(+time < new Date().getTime()){
                dispatch(logout());
            }else{
                let userid = localStorage.getItem('userId');
                dispatch(onAuthSucces({localId: userid, idToken : token}));
                dispatch(checkTokenValidity(time - new Date().getTime()));
            }
        }
    }
}